/* ==========================================================================
   RasCommerce — product page behaviour

   Variant matching, price / inventory / SKU updates, gallery filtering by
   colour, sticky add-to-cart and quick view.
   ========================================================================== */
(function () {
  'use strict';

  var RC = (window.RC = window.RC || {});

  var COLOR_NAMES = ['color', 'colour', 'couleur', 'farbe', 'kleur', 'cor', 'colore'];

  function parseJSON(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /* ---------------------------------------------------------- Controller */

  function ProductSection(root) {
    this.root = root;
    this.sectionId = root.dataset.sectionId;

    this.variants = parseJSON(document.querySelector('[data-rc-variant-data="' + this.sectionId + '"]')) || [];
    this.product = parseJSON(document.querySelector('[data-rc-product-data="' + this.sectionId + '"]')) || {};

    this.picker = root.querySelector('[data-rc-variant-picker]');
    this.form = root.querySelector('[data-rc-product-form]');
    this.variantInput = root.querySelector('[data-rc-variant-id]');
    this.addButton = root.querySelector('[data-rc-add-button]');
    this.addText = root.querySelector('[data-rc-add-text]');

    this.currentVariant = this.findVariantById(this.variantInput && this.variantInput.value);

    this.bind();
  }

  ProductSection.prototype.findVariantById = function (id) {
    if (!id) return null;
    var numeric = parseInt(id, 10);
    for (var i = 0; i < this.variants.length; i++) {
      if (this.variants[i].id === numeric) return this.variants[i];
    }
    return null;
  };

  ProductSection.prototype.selectedOptions = function () {
    if (!this.picker) return [];

    var options = [];

    // Swatch / button style
    this.picker.querySelectorAll('[data-rc-option-input]:checked').forEach(function (input) {
      var index = parseInt(input.dataset.optionIndex, 10) - 1;
      options[index] = input.value;
    });

    // Dropdown style
    this.picker.querySelectorAll('[data-rc-option-select]').forEach(function (select) {
      var index = parseInt(select.dataset.optionIndex, 10) - 1;
      options[index] = select.value;
    });

    return options;
  };

  ProductSection.prototype.matchVariant = function (options) {
    for (var i = 0; i < this.variants.length; i++) {
      var variant = this.variants[i];
      var match = true;
      for (var j = 0; j < options.length; j++) {
        if (options[j] !== undefined && variant.options[j] !== options[j]) {
          match = false;
          break;
        }
      }
      if (match) return variant;
    }
    return null;
  };

  /**
   * Mark option values that cannot be combined with the current selection.
   * Only later options are evaluated against earlier ones, which mirrors how
   * shoppers narrow down a choice.
   */
  ProductSection.prototype.updateAvailability = function (selected) {
    if (!this.picker) return;
    var self = this;

    this.picker.querySelectorAll('[data-rc-option-input]').forEach(function (input) {
      var index = parseInt(input.dataset.optionIndex, 10) - 1;
      var candidate = selected.slice();
      candidate[index] = input.value;

      // Only constrain by options chosen before this one.
      for (var i = index + 1; i < candidate.length; i++) {
        candidate[i] = undefined;
      }

      var exists = self.variants.some(function (variant) {
        if (!variant.available) return false;
        for (var i = 0; i < candidate.length; i++) {
          if (candidate[i] !== undefined && variant.options[i] !== candidate[i]) return false;
        }
        return true;
      });

      var label = self.picker.querySelector('label[for="' + input.id + '"]');
      if (label) label.classList.toggle('rc-variant-unavailable', !exists);
    });
  };

  ProductSection.prototype.updateLabels = function (selected) {
    if (!this.picker) return;
    var self = this;
    this.picker.querySelectorAll('[data-rc-option-label]').forEach(function (label) {
      var index = parseInt(label.dataset.rcOptionLabel, 10) - 1;
      if (selected[index] !== undefined) label.textContent = selected[index];
      void self;
    });
  };

  ProductSection.prototype.updatePrice = function (variant) {
    var block = this.root.querySelector('[data-rc-price-block]');
    if (!block || !variant) return;

    var current = block.querySelector('[data-rc-current-price]');
    var compare = block.querySelector('[data-rc-compare-price]');
    var badge = block.querySelector('[data-rc-save-badge]');

    if (current) current.innerHTML = RC.formatMoney(variant.price);

    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

    if (compare) {
      compare.innerHTML = onSale ? RC.formatMoney(variant.compare_at_price) : '';
      compare.hidden = !onSale;
    }

    if (badge) {
      if (onSale) {
        var saved = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        var span = badge.querySelector('span');
        if (span) span.textContent = saved;
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    }
  };

  ProductSection.prototype.updateSku = function (variant) {
    var sku = this.root.querySelector('[data-rc-sku]');
    if (sku) sku.textContent = (variant && variant.sku) || '—';
  };

  ProductSection.prototype.updateInventory = function (variant) {
    var el = this.root.querySelector('[data-rc-inventory]');
    if (!el || !variant) return;

    var text = el.querySelector('[data-rc-inventory-text]');
    var threshold = parseInt(el.dataset.threshold, 10) || 0;
    var showCount = el.dataset.showCount === 'true';
    var strings = RC.strings;

    el.classList.remove('rc-inventory-in', 'rc-inventory-low', 'rc-inventory-out');

    if (!variant.available) {
      el.classList.add('rc-inventory-out');
      if (text) text.textContent = strings.outOfStock || 'Out of stock';
      return;
    }

    var managed = variant.inventory_management;
    var qty = variant.inventory_quantity;

    if (managed && variant.inventory_policy === 'deny' && qty > 0 && qty <= threshold) {
      el.classList.add('rc-inventory-low');
      if (text) {
        text.textContent = showCount
          ? (strings.lowStockCount || 'Only [count] left in stock').replace('[count]', qty)
          : strings.lowStock || 'Low stock';
      }
    } else {
      el.classList.add('rc-inventory-in');
      if (text) text.textContent = strings.inStock || 'In stock';
    }
  };

  ProductSection.prototype.updateButton = function (variant) {
    if (!this.addButton) return;

    var available = variant && variant.available;
    this.addButton.disabled = !available;

    if (this.addText) {
      if (!variant) {
        this.addText.textContent = RC.strings.unavailable;
      } else if (!variant.available) {
        this.addText.textContent = RC.strings.soldOut;
      } else {
        this.addText.textContent = RC.strings.addToCart;
      }
    }

    if (this.variantInput) {
      this.variantInput.value = variant ? variant.id : '';
      this.variantInput.disabled = !variant;
    }

    var stickyAdd = this.root.querySelector('[data-rc-sticky-add]');
    if (stickyAdd) stickyAdd.disabled = !available;
  };

  /**
   * When a colour is chosen, scroll the gallery to that colour's first image
   * and hide media belonging to other colours.
   */
  ProductSection.prototype.updateGallery = function (variant, selected) {
    var gallery = this.root.querySelector('[data-rc-gallery]');
    if (!gallery || !variant) return;

    var colorIndex = -1;
    var options = this.product.options || [];
    for (var i = 0; i < options.length; i++) {
      if (COLOR_NAMES.indexOf(String(options[i]).toLowerCase()) !== -1) {
        colorIndex = i;
        break;
      }
    }

    var color = colorIndex > -1 ? selected[colorIndex] : null;

    if (color) {
      var hasColored = gallery.querySelector('[data-color]');
      if (hasColored) {
        gallery.querySelectorAll('[data-media-id]').forEach(function (slide) {
          var slideColor = slide.dataset.color;
          var show = !slideColor || slideColor === color;
          slide.classList.toggle('rc-media-hidden', !show);
        });
      }
    }

    // Jump to the variant's own image when it has one.
    if (variant.featured_media) {
      var main = gallery.querySelector('.tf-product-media-main');
      if (main && main.swiper) {
        var slides = main.querySelectorAll('.swiper-slide');
        for (var s = 0; s < slides.length; s++) {
          if (parseInt(slides[s].dataset.mediaId, 10) === variant.featured_media.id) {
            main.swiper.slideTo(s);
            break;
          }
        }
      } else {
        var target = gallery.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (target && target.scrollIntoView) {
          target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    }

    var stickyImage = this.root.querySelector('[data-rc-sticky-image]');
    if (stickyImage && variant.featured_image) {
      stickyImage.src = variant.featured_image.src || stickyImage.src;
    }
  };

  ProductSection.prototype.updateUrl = function (variant) {
    if (!variant || !window.history.replaceState) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  };

  ProductSection.prototype.onChange = function () {
    var selected = this.selectedOptions();
    var variant = this.matchVariant(selected);

    this.currentVariant = variant;

    this.updateLabels(selected);
    this.updateAvailability(selected);
    this.updateButton(variant);

    if (variant) {
      this.updatePrice(variant);
      this.updateSku(variant);
      this.updateInventory(variant);
      this.updateGallery(variant, selected);
      this.updateUrl(variant);

      document.dispatchEvent(
        new CustomEvent('rc:variant:changed', { detail: { variant: variant, sectionId: this.sectionId } })
      );
    }
  };

  ProductSection.prototype.bind = function () {
    var self = this;

    if (this.picker) {
      this.picker.addEventListener('change', function (event) {
        if (event.target.matches('[data-rc-option-input], [data-rc-option-select]')) {
          self.onChange();
        }
      });
    }

    // Sticky bar mirrors the main form.
    var stickyAdd = this.root.querySelector('[data-rc-sticky-add]');
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        if (!self.currentVariant) return;
        var qtyInput = self.root.querySelector('[data-rc-sticky-qty]');
        var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

        stickyAdd.classList.add('rc-loading');
        RC.cart
          .add({ items: [{ id: self.currentVariant.id, quantity: quantity }] })
          .finally(function () {
            stickyAdd.classList.remove('rc-loading');
          });
      });
    }

    // Run once so availability marks and labels reflect the initial state.
    if (this.picker) this.onChange();
  };

  /* ----------------------------------------------------------- Quick view */

  function openQuickView(url) {
    var modal = document.getElementById('quick_view');
    if (!modal) {
      window.location.href = url;
      return;
    }

    var body = modal.querySelector('[data-rc-quick-view-body]');
    if (!body) return;

    body.innerHTML = '<div class="rc-quickview-loading text-center py-5"><span class="rc-spinner"></span></div>';

    if (window.bootstrap) {
      window.bootstrap.Modal.getOrCreateInstance(modal).show();
    }

    var separator = url.indexOf('?') === -1 ? '?' : '&';

    RC.fetchText(url + separator + 'section_id=quick-view')
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('[data-rc-quick-view-content]');
        body.innerHTML = content ? content.innerHTML : '';

        if (RC.initCarousels) {
          RC.initCarousels(body);
          RC.initCarousels(body);
        }
        initSections(body);
      })
      .catch(function () {
        body.innerHTML = '<p class="text-center py-5">' + RC.strings.cartError + '</p>';
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-rc-quick-view]');
    if (!trigger) return;

    var url = trigger.dataset.productUrl;
    if (!url) return;

    event.preventDefault();
    openQuickView(url);
  });

  /* ----------------------------------------------------------------- Init */

  function initSections(scope) {
    scope.querySelectorAll('[data-rc-product-section]').forEach(function (root) {
      if (root.dataset.rcBound) return;
      root.dataset.rcBound = 'true';
      new ProductSection(root);
    });
  }

  RC.ProductSection = ProductSection;
  RC.onSectionLoad(function (scope) {
    initSections(scope === document ? document : scope);
  });
})();
